import React from "react";
import s from "./style.module.scss";
import MagnifyingGlass from "./icons/MagnifyingGlass";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";

const Search: React.FC = () => {
  return (
    <Link to={ROUTES_PATH.SEARCH} className={s.search}>
      <span>Поиск..</span>

      <MagnifyingGlass />
    </Link>
  );
};

export default Search;
